var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    fill: "none",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.5.69a20 20 0 1 0 0 40 20 20 0 0 0 0-40M10.1 17.25h4.53v13.62H10.1zm4.83-4.2c-.03-1.34-.98-2.36-2.53-2.36s-2.57 1.02-2.57 2.35c0 1.31.99 2.36 2.5 2.36h.04c1.58 0 2.56-1.05 2.56-2.36Zm10.83 3.89c2.98 0 5.22 1.94 5.22 6.12v7.81h-4.53V23.6c0-1.83-.66-3.08-2.3-3.08a2.5 2.5 0 0 0-2.47 2.75v7.61h-4.54s.06-12.34 0-13.61h4.54v1.92a4.5 4.5 0 0 1 4.08-2.24Z",
    clipRule: "evenodd"
  })));
};
export default SvgLinkedIn;